function Form($form){

	var self = this;
	self.$form = $form;
	self.mailRegEx = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	self.$required = self.$form.find('[required]');

	self.$required.on('validate', function(){

		var $field = $(this),
			type = $field.is('input') ? $field.attr('type') : $field.prop('tagName').toLowerCase();

		if((type == 'text' || type == 'textarea') && $field.val().trim() == '')
			$field.addClass('required')
		else if(type == 'email' && ($field.val().trim() == '' || !self.mailRegEx.test($field.val())))
			$field.addClass('required')
		else if(type == 'checkbox' && !$field.is(':checked'))
			$field.addClass('required')
		else
			$field.removeClass('required');

	})

	self.$form.on('keyup change', '.required', function(){
		$(this).trigger('validate');
	})

	self.$form.attr('novalidate', '');
        self.$form.on('submit', function (e) {
            e.preventDefault();
            self.$required.trigger('validate');
            if (!self.$form.find('.required').length) {
                self.$form.addClass('is-sending');
                self.$form.find('[type="submit"]').prop('disabled', true);

                //$.post(self.$form.attr('action'), self.$form.serialize(), function (data) {});
                var formUpper = self.$form;
                $.ajax({
                    type: "POST",
                    url: "" + self.$form.attr('action') + "",
                    data: "{ data: '" + self.$form.serialize() + "' }",
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    complete: function (msg, status) {
                        //console.log(msg);
                        //console.log(msg.statusText);
                        //console.log(msg.statusText == "OK");
                        if (msg.statusText == "OK") {
                            setTimeout(function () {
                                formUpper.removeClass('is-sending');
                                formUpper.addClass('sent');
                                setTimeout(function () {
                                    formUpper.get(0).reset();
                                    formUpper.removeClass('sent');
                                    formUpper.find('[type="submit"]').prop('disabled', false);
                                }, 3000);
                            }, 2000);
                        } else {
                            setTimeout(function () {
                                formUpper.removeClass('is-sending');
                                setTimeout(function () {
                                    formUpper.removeClass('sent');
                                    formUpper.find('[type="submit"]').prop('disabled', false);
                                }, 3000);
                            }, 2000);
                        }
                    }
                });

            }
        });
        self.$form.on('reset', function () {
            self.$form.removeClass('is-sending');
            self.$form.removeClass('sent');
            self.$form.find('[type="submit"]').prop('disabled', false);
            self.$form.find('[required]').removeClass('required');
            self.$form.get(0).reset();
        });

}

module.exports = Form;


/** WEBPACK FOOTER **
 ** ./components/form.js
 **/